export const navigation = {
  support: {
    question: "هل تحتاج إلى مساعدة؟",
    whatsappCta: "راسلنا عبر WhatsApp",
  },
  alt: {
    whatsapp: "أيقونة WhatsApp",
    logo: "شعار لوحة التحكم",
  },
};
